import { getLocaleWithCountry } from "app-settings/localesAndCurrencies";
import axios from "./axios";

export const TRUSTPILOT_API_URL = "/api/airhelp_score";

const fetchTrustpilotScore = async (locale?: string) => {
  const { data } = await axios
    .get<TrustpilotScoreType>(TRUSTPILOT_API_URL, {
      params: { locale: getLocaleWithCountry(locale) },
    })
    .then((response) => response);

  return {
    totalReviews: data.totalReviews,
    scoreValue: data.scoreValue,
    trustpilotLink: data.trustpilotLink,
  };
};

export const DEFAULT_TRUSTPILOT_SCORE = {
  totalReviews: 210697,
  scoreValue: 4.6,
  trustpilotLink: "https://www.trustpilot.com/review/www.airhelp.com",
};

export type TrustpilotScoreType = {
  totalReviews: number;
  scoreValue: number;
  trustpilotLink: string;
};

const trustpilotApi = {
  fetchTrustpilotScore,
};

export default trustpilotApi;
